import React, { useState } from "react"
import { gql, useMutation } from "@apollo/client"
import { Button } from "@mui/material"

const FILE_UPLOAD_MUTATION = gql`
  mutation FileUpload(
    $base64str: String!
    $file_name: String!
    $file_type: String!
    $user_id: Int!
  ) {
    fileUpload(
      base64str: $base64str
      user_id: $user_id
      file_name: $file_name
      file_type: $file_type
    ) {
      file_path
    }
  }
`

function FileUpload() {
  const [file, setFile] = useState(null)
  const [base64Str, setBase64Str] = useState(null)
  const [filepath, setFilePath] = useState(null)
  const [fileUploadMutation] = useMutation(FILE_UPLOAD_MUTATION)
  console.log(setFilePath)
  const fileUploadAction = () => {
    // make fetch api call to upload file
    //const { name: fileName, type: fileType } = file
    const variables = {
      file_name: file.name,
      file_type: file.type,
      base64str: base64Str,
      user_id: 1,
    }
    const res = fileUploadMutation({ variables })
    console.log(res)
  }
  const onChange = (e) => {
    setFile(e.target.files[0])
    const reader = new FileReader()
    if (e.target.files[0]) {
      reader.readAsBinaryString(e.target.files[0])
    }
    reader.onload = function () {
      const base64str = window.btoa(reader.result)
      console.log(base64str)
      setBase64Str(base64str)
    }
    reader.onerror = function () {
      console.log("Unable to parse file")
    }
  }
  return (
    <div className="App">
      <h1>File Upload</h1>
      <input type="file" onChange={onChange} required />
      <Button onClick={fileUploadAction}>Upload</Button>
      <div>{filepath ? <a href={filepath}>{filepath}</a> : null}</div>
    </div>
  )
}

export default FileUpload
